import { ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import { fromEvaluations, evaluationsActions, UpdateMultipleStatusParams } from './evaluations';
import { useShowErrorIfRejected } from 'utils/hooks/useShowErrorIfRejected';
import { Map } from 'immutable';

/**
 * Custom hook to update the status of multiple evaluations.
 *
 * @returns {Object} An object containing:
 *   - isSaving: A boolean indicating if the update operation is in progress.
 *   - updateMultipleStatus: A function to update the status of multiple evaluations.
 */
export const useUpdateMultipleStatus = () => {
  const showErrorIfRejected = useShowErrorIfRejected();

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const isSaving = useSelector((state: Map<string, any>) =>
    fromEvaluations.getIsSaving(state?.toJS()),
  );

  const updateMultipleStatus = async (params: UpdateMultipleStatusParams) => {
    return showErrorIfRejected(await dispatch(evaluationsActions.updateMultipleStatus(params)));
  };

  return { isSaving, updateMultipleStatus };
};
